import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgDrop = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M17.4167 15.4558C17.4167 16.9477 16.8241 18.3784 15.7692 19.4333C14.7143 20.4882 13.2836 21.0808 11.7917 21.0808C10.2999 21.0808 8.86916 20.4882 7.81427 19.4333C6.75938 18.3784 6.16675 16.9477 6.16675 15.4558C6.16675 11.3975 9.87341 5.27916 11.2684 3.1225C11.3245 3.03457 11.4019 2.9622 11.4934 2.91207C11.5848 2.86194 11.6874 2.83566 11.7917 2.83566C11.8961 2.83566 11.9987 2.86194 12.0901 2.91207C12.1816 2.9622 12.259 3.03457 12.3151 3.1225C13.7101 5.27916 17.4167 11.3975 17.4167 15.4558Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.7917 18.5833C11.3812 18.5833 10.9746 18.5024 10.5953 18.3452C10.216 18.188 9.87137 17.9576 9.58116 17.6672C9.29094 17.3767 9.06081 17.0319 8.90391 16.6525C8.74701 16.2731 8.66642 15.8664 8.66675 15.4558"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgDrop.displayName = 'SvgDrop';
export default SvgDrop;
